// Owner: P1 piece 5 "Touch ledger and Today" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): keep the one export `feature` and its type; fill
// `app`/`bare` and `nav`. Paths: `/touches`. No rail entry: the `nav` message area has no label for it, so the ledger
// is reached from Today's pulse tile, the organisation page and the Pipeline header. The search (ids and codes, never
// text) is parsed in search.ts, which the screen imports instead of this file (CONTRACTS 23.6).
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import type { Feature } from '../feature.ts'
import { parseSearch } from './search.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/touches',
      validateSearch: (search: Record<string, unknown>) => parseSearch(search),
      component: lazyRouteComponent(() => import('./TouchesScreen.tsx')),
    }),
  ],
  nav: [],
}
